'use client';

import { PcpStatusType } from '@/app/(intakeFormV2)/intake-v2/types';
import { useCallback, useState } from 'react';
import { useIntakeWizardContext } from '../../contexts/WizardProvider';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import { IntakeRadioGroup } from '../common/IntakeRadioGroup';
import { IntakeStepWrapper } from '../common/IntakeStepWrapper';

const PCP_STATUS_OPTIONS = [
  {
    value: 'Yes, I have a concierge primary care physician',
    label: 'Yes, I have a concierge PCP',
  },
  {
    value: 'Yes, I have a traditional primary care physician',
    label: 'Yes, I have a traditional in-network PCP',
  },
  {
    value: "No, I don't currently have a primary care physician",
    label: 'No, I don’t currently have a PCP',
  },
  { value: "I'm not sure", label: "I'm not sure" },
];

export const PcpStatusStep = () => {
  const { state, dispatch } = useIntakeWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const pcpStatus = state.formData?.pcp_status;

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { pcp_status: value as PcpStatusType },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();

      if (!pcpStatus) {
        setError('Please select an option');

        return;
      }

      goToNextStep();
    },
    [pcpStatus, goToNextStep]
  );

  return (
    <IntakeStepWrapper
      heading='Do you currently have a primary care physician (PCP)?'
      description='Sollis coordinates with your doctor to ensure continuity of care while handling your immediate medical needs.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <IntakeRadioGroup
        name='pcp_status'
        options={PCP_STATUS_OPTIONS}
        value={pcpStatus}
        onChange={handleChange}
        error={error}
      />
    </IntakeStepWrapper>
  );
};
